module.exports = __webpack_public_path__ + "img/small.a54d9c1a.jpg";